module.exports = __webpack_public_path__ + "static/media/Delete.00a1c860.svg";